export default {
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  bgColor: 'white',
  border: true,
  borderWidth: '1',
  padding: '2',
  fontSize: '3',
  showOriginDestinationImage: false,
  separatorJourneyTypeProps: {
    content: '|',
    fontWeight: 'bold',
  },
  showJourneyType: true,
  fareItemJourneyType: {
    fontWeight: 'bold',
  },
  showTravelClass: true,
  fareItemTravelClass: {
    fontWeight: 'bold',
  },
  fareItemOriginDestination: {
    showOriginAirportCode: true,
    showDestinationAirportCode: true,
    showSeparator: true,
    separatorKey: 'to',
    fontWeight: 'bold',
    fontSize: '4',
    textTransform: 'uppercase',
    marginBottom: '2',
    style: {
      lineHeight: '1',
    },
    separatorStyles: {
      paddingLeft: '1',
      textTransform: 'lowercase',
      fontWeight: 'light',
    },
  },
  showDepartureInfo: true,
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: true,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  showDurationTrip: true,
  fareItemTripDuration: {
    fontWeight: 'bold',
  },
  fareBodyItem: {
    grow: '2',
    textColor: 'dark',
    justifyContent: 'between',
  },
  fareFooterItem: {
    justifyContent: 'end',
    alignItems: 'end',
    grow: '1',
    textColor: 'dark',
  },
  showPrice: true,
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: false,
    fontWeight: 'bold',
    textAlign: 'right',
    pricePromoStyles: {
      fontWeight: 'bold',
      fontSize: '3',
    },
    currencyStyles: {
      fontSize: '5',
    },
  },
  fareItemCallToAction: {
    shadow: '@theme:button.shadow',
    rounded: '@theme:button.rounded',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
    paddingHeight: '1',
    style: {
      paddingLeft: '2rem',
      paddingRight: '2rem',
    },
  },
  showCallToAction: true,
  showLastSeen: true,
  fareItemLastSeen: {
    paddingBottom: '1',
    labelStyles: {
      fontWeight: 'bold',
      textColor: 'dark',
    },
    dateStyles: {
      textColor: 'dark',
    },
  },
};
